<div class="flex flex-col pt-44 md:pt-[12px] mt-16 lg:mt-4 mb-4 gap-6">
  <ng-container *ngIf="allSections$ | async as vm;else loading">
    <div *ngFor="let sectionData of vm; let i = index">
      <div [ngSwitch]="sectionData?.Section?.ViewName" class="flex flex-col container lg:px-0">
        <ng-container class="main-section-wrapper" *ngComponentOutlet="
        sectionData?.Section?.ViewName | getFlexSection;
        inputs: { dataSource: sectionData }
       "></ng-container>
      </div>
    </div>
    <div class="main-section-wrapper container mt-6">
      <h2 class="text-2xl font-bold">رزرو هتل،هتل آپارتمان و اقامت بلند مدت</h2>
      <iho-iranhotel-info />
    </div>

  </ng-container>
  <ng-template #loading>
    <div class="container flex flex-col pt-44 md:pt-[12px] mt-16 lg:mt-4 mb-4 gap-6">
      <iho-banners-skeleton />
      <iho-slider-bg-text-skeleton />
    </div>
  </ng-template>
</div>
